// @flow
import React from "react";
import styled from "styled-components";
import Helmet from "react-helmet";
import Moment from "moment";

import { getImage } from "@nested/utils";
import { H1, H6, P, media } from "@nested/ui";
import FormComponent from "./Form";

const Wrapper = styled.section`
  background-color: ${({ theme }) => theme.palette.blue.light};
  width: 100%;
  height: 100%;
  padding: 0px 10px;
  ${media.tablet`
    padding: 0px 35px;
  `};
`;

const Content = styled.section`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-top: 80px;
  margin-bottom: 50px;
`;

const SplitViewWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column-reverse;
  ${media.desktop`
    flex-direction: row;
  `}
`;

const LeftContainer = styled.div`
  margin: 20px 0px 25px;
  width: 100%;
  max-width: 565px;
  ${media.tablet`
    margin: 0;
    width: 75%;
  `};
  ${media.desktop`
    margin: 70px 40px 0px 80px;
    width: 60%;
  `}
`;

const GenericContainer = styled.div`
  padding-bottom: 25px;
  margin: 0 auto;
  max-width: 566px;
  ${media.tablet`
    padding-top: 80px;
  `};
`;

const BabyMobile = styled.div`
  display: flex;
  justify-content: center;
  width: 80%;
  ${media.tablet`
    margin-top: 40px;
    width: 40%;
  `}
  ${media.desktop`
    margin-top: 80px;
    width: 40%;
  `}
  img {
    ${media.desktop`
      height: 373px;
    `}
  }
`;

const HeadingTitle = styled(H1)`
  margin-top: 30px;
  ${media.tablet`
    max-width: unset;
    margin: 30px 0;
  `}
  ${media.desktop`
    font-size: 48px;
    line-height: 60px;
  `}
`;

const SeeExampleText = styled(H6)`
  text-align: center;
  padding-top: 30px;
  margin-bottom: 0;
`;

type Props = {
  babyTheme: boolean,
  submitError: any,
  exampleView: boolean,
  today: Moment,
};

const GenericHeader = ({ submitError, today }) => (
  <GenericContainer>
    <HeadingTitle left id="title">
      How long will your home take to sell?
    </HeadingTitle>
    <P left>
      Take the stress away of guessing when to list for sale with our moving
      calculator that estimates how long your home move will take.
    </P>
    <FormComponent today={today} submitError={submitError} />
  </GenericContainer>
);

const BabyHeader = ({ submitError, today }) => (
  <>
    <SplitViewWrapper>
      <LeftContainer>
        <HeadingTitle left id="title">
          What to expect from your home sale when you&apos;re expecting
        </HeadingTitle>
        <P left>
          A new baby often means a new home. Take the stress away of guessing
          when to list for sale with our moving calculator that estimates how
          long your home move will take.
        </P>
        <FormComponent today={today} submitError={submitError} />
      </LeftContainer>
      <BabyMobile>
        <img
          src={getImage(
            "baby-themed-illustrations/baby_mobile_illustration.svg",
          )}
          alt="baby mobile"
        />
      </BabyMobile>
    </SplitViewWrapper>
  </>
);

const LandingSection = ({
  babyTheme,
  submitError,
  exampleView,
  today,
}: Props) => (
  <>
    <Helmet>
      <title>Your home sale timeline</title>
    </Helmet>
    <Wrapper>
      <Content>
        {babyTheme ? (
          <BabyHeader today={today} submitError={submitError} />
        ) : (
          <GenericHeader today={today} submitError={submitError} />
        )}
        {exampleView && <SeeExampleText center>See an example</SeeExampleText>}
      </Content>
    </Wrapper>
  </>
);

export default LandingSection;
